export default "__VITE_ASSET__BBmFC$HS__"